const common = {
  helloWorld: 'hello world',
  linkSent: 'Link Sent',
}

export default common
